"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markMessageRead = exports.INBOX_MARK_MESSAGE_READ = void 0;
var INBOX_MARK_MESSAGE_READ = "inbox/MARK_MESSAGE_READ";
exports.INBOX_MARK_MESSAGE_READ = INBOX_MARK_MESSAGE_READ;

var markMessageRead = function markMessageRead(messageId) {
  return {
    type: INBOX_MARK_MESSAGE_READ,
    payload: {
      messageId: messageId
    }
  };
};

exports.markMessageRead = markMessageRead;